export default "__VITE_ASSET__FVOWZa8b__"